import { render, staticRenderFns } from "./LoginModalShell.vue?vue&type=template&id=3fb48245&scoped=true"
import script from "./LoginModalShell.vue?vue&type=script&lang=js"
export * from "./LoginModalShell.vue?vue&type=script&lang=js"
import style0 from "./LoginModalShell.vue?vue&type=style&index=0&id=3fb48245&prod&lang=css"
import style1 from "./LoginModalShell.vue?vue&type=style&index=1&id=3fb48245&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb48245",
  null
  
)

export default component.exports